import { CurrentCartState } from '@common/store';
import { TestData_PASSENGER as PASS } from '../passenger-test-data';
import { TestData_BOUND as BOUND } from '../bound-test-data';
import { Bound, Traveler } from 'src/sdk-reservation';
import { PassengerType } from '@common/interfaces';

export function getCurrentCartTestData1(id: string = 'CART_ID001'): any {
  const ret = getCurrentCartTestData([BOUND.BOUND_R01M60_1]);
  ret.data.cartId = id;
  return ret;
}
export function getCurrentCartTestData1Nomiddle(): any {
  return getCurrentCartTestData([BOUND.BOUND_R01M60_1], TravelerNoMiddle);
}
export function getCurrentCartTestData1All21Under(): any {
  return getCurrentCartTestData([BOUND.BOUND_R01M60_1], TravelerU21);
}
export function getCurrentCartTestData1All21UnderNh(): any {
  return getCurrentCartTestData([BOUND.BOUND_R01M60_1_NH], TravelerU21);
}
export function getCurrentCartTestData1Eq21(): any {
  return getCurrentCartTestData([BOUND.BOUND_R01M60_1], TravelerU21Equal);
}
export function getCurrentCartTestData1Eq21Dep(): any {
  return getCurrentCartTestData([BOUND.BOUND_R01M60_1], TravelerU21EqualDep);
}
export function getCurrentCartTestData2(): any {
  return getCurrentCartTestData([BOUND.BOUND_R01M60_2]);
}
export function getCurrentCartTestData2All18Under(): any {
  return getCurrentCartTestData([BOUND.BOUND_R01M60_2], TravelerU18);
}
export function getCurrentCartTestData2Eq18(): any {
  return getCurrentCartTestData([BOUND.BOUND_R01M60_2], TravelerU18Equal);
}
export function getCurrentCartTestData2Eq18Dep(): any {
  return getCurrentCartTestData([BOUND.BOUND_R01M60_2], TravelerU18EqualDep);
}
export function getCurrentCartTestData2Eq18Dep2(): any {
  return getCurrentCartTestData([BOUND.BOUND_R01M60_2], TravelerU18EqualDep2);
}
export function getCurrentCartTestData3(): any {
  return getCurrentCartTestData([BOUND.BOUND_R01M60_3]);
}
export function getCurrentCartTestData3All18Under(): any {
  return getCurrentCartTestData([BOUND.BOUND_R01M60_3], TravelerU18);
}
export function getCurrentCartTestData3Eq18(): any {
  return getCurrentCartTestData([BOUND.BOUND_R01M60_3], TravelerU18Equal);
}
export function getCurrentCartTestData3Eq18Dep(): any {
  return getCurrentCartTestData([BOUND.BOUND_R01M60_3], TravelerU18EqualDep);
}
export function getCurrentCartTestData3Eq18Dep2(): any {
  return getCurrentCartTestData([BOUND.BOUND_R01M60_3], TravelerU18EqualDep2);
}
export function getCurrentCartTestData4(): any {
  return getCurrentCartTestData([BOUND.BOUND_R01M60_4]);
}
export function getCurrentCartNotU12AndU4(): any {
  return getCurrentCartTestData([BOUND.bound7], TravelerNotU12AndU4);
}
export function getCurrentCartU12AndU4(): any {
  return getCurrentCartTestData([BOUND.bound7], TravelerU12AndU4);
}
export function getCurrentCartNotU12AndNotU4(): any {
  return getCurrentCartTestData([BOUND.bound7], TravelerNotU12AndNotU4);
}
export function getCurrentCartNotU12AndU4Pnr(): any {
  return getCurrentCartTestData([BOUND.bound7], TravelerNotU12AndU4, true);
}
export function getCurrentCartAllChd(): any {
  return getCurrentCartTestData([BOUND.bound7], TravelerAllChd);
}
export function getCurrentCartAllChdAndAdt(): any {
  return getCurrentCartTestData([BOUND.bound7], TravelerAllChdAndAdt);
}
export function getCurrentCartAllChdPnr(): any {
  return getCurrentCartTestData([BOUND.bound7], TravelerAllChd, true);
}
export function getCurrentCartDisAbilityDuplicate(): any {
  return getCurrentCartTestData([BOUND.bound7], TravelerADisAbility1);
}
export function getCurrentCartDisAbilitySuccess(): any {
  return getCurrentCartTestData([BOUND.bound7], TravelerADisAbility2);
}
function getCurrentCartTestData(
  bounds: Array<Bound>,
  travelers: Array<Traveler> = defaultTraveler,
  hasAccompaniedInAnotherReservation: boolean = false
): any {
  const data: CurrentCartState = {
    requestIds: [],
    data: {
      cartId: 'CART_ID001',
      plan: {
        airOffer: {
          bounds: bounds,
        },
        travelers: travelers,
        travelersSummary: {
          numberOfTraveler: {
            ADT: travelers.filter((trav) => trav.passengerTypeCode === PassengerType.ADT).length,
            B15: travelers.filter((trav) => trav.passengerTypeCode === PassengerType.B15).length,
            CHD: travelers.filter((trav) => trav.passengerTypeCode === PassengerType.CHD).length,
            INF: travelers.filter((trav) => trav.passengerTypeCode === PassengerType.INF).length,
          },
          hasAccompaniedInAnotherReservation: hasAccompaniedInAnotherReservation,
        },
      },
    },
  };
  return data;
}

const defaultTraveler = [
  PASS.TRAVELER_R01_M60_1,
  PASS.TRAVELER_R01_M60_2,
  PASS.TRAVELER_R01_M60_3,
  PASS.TRAVELER_R01_M60_4,
  PASS.TRAVELER_R01_M60_5,
];
const TravelerNoMiddle = [
  PASS.TRAVELER_R01_M60_1,
  PASS.TRAVELER_R01_M60_2,
  { ...PASS.TRAVELER_R01_M60_3, names: [{ title: 'MR', firstName: '空次郎', lastName: '山野', middleName: '' }] },
  PASS.TRAVELER_R01_M60_4,
  PASS.TRAVELER_R01_M60_5,
];

const TravelerU21 = [
  { ...PASS.TRAVELER_R01_M60_1, dateOfBirth: '2003/1/1' },
  { ...PASS.TRAVELER_R01_M60_2, dateOfBirth: '2003/1/1' },
  PASS.TRAVELER_R01_M60_3,
  PASS.TRAVELER_R01_M60_4,
  PASS.TRAVELER_R01_M60_5,
];

const TravelerU21Equal = [
  { ...PASS.TRAVELER_R01_M60_1, dateOfBirth: '2001/12/1' },
  { ...PASS.TRAVELER_R01_M60_2, dateOfBirth: '2003/1/1' },
  PASS.TRAVELER_R01_M60_3,
  PASS.TRAVELER_R01_M60_4,
  PASS.TRAVELER_R01_M60_5,
];
const TravelerU21EqualDep = [
  { ...PASS.TRAVELER_R01_M60_1, dateOfBirth: '2002/1/1' },
  { ...PASS.TRAVELER_R01_M60_2, dateOfBirth: '2003/1/1' },
  PASS.TRAVELER_R01_M60_3,
  PASS.TRAVELER_R01_M60_4,
  PASS.TRAVELER_R01_M60_5,
];

const TravelerU18 = [PASS.TRAVELER_R01_M60_1, { ...PASS.TRAVELER_R01_M60_2, dateOfBirth: '2005/1/12' }];

const TravelerU18Equal = [PASS.TRAVELER_R01_M60_1, { ...PASS.TRAVELER_R01_M60_2, dateOfBirth: '2004/12/1' }];
const TravelerU18EqualDep = [PASS.TRAVELER_R01_M60_1, { ...PASS.TRAVELER_R01_M60_2, dateOfBirth: '2005/1/1' }];

const TravelerU18EqualDep2 = [PASS.TRAVELER_R01_M60_1, { ...PASS.TRAVELER_R01_M60_2, dateOfBirth: '2005/1/10' }];
const TravelerNotU12AndU4 = [PASS.TRAVELER_R01_M60_7, PASS.TRAVELER_R01_M60_8];
const TravelerU12AndU4 = [PASS.TRAVELER_R01_M60_6, PASS.TRAVELER_R01_M60_8];
const TravelerNotU12AndNotU4 = [PASS.TRAVELER_R01_M60_7];
const TravelerAllChd = [PASS.TRAVELER_R01_M60_7];
const TravelerAllChdAndAdt = [PASS.TRAVELER_R01_M60_1, PASS.TRAVELER_R01_M60_7];
const TravelerADisAbility1 = [
  PASS.TRAVELER_DISABILITY_CAREGIVER_1,
  PASS.TRAVELER_DISABILITY_CAREGIVER_2,
  PASS.TRAVELER_DISABILITY_1,
  PASS.TRAVELER_DISABILITY_2,
  PASS.TRAVELER_DISABILITY_3,
];
const TravelerADisAbility2 = [
  PASS.TRAVELER_DISABILITY_CAREGIVER_1,
  PASS.TRAVELER_DISABILITY_CAREGIVER_2,
  PASS.TRAVELER_DISABILITY_2,
  PASS.TRAVELER_DISABILITY_3,
];
